<template>
  <v-menu
    bottom left
    offset-y
    :close-on-content-click="false"
    content-class="main-menu"
  >
    <div slot="activator" @click.native="track">
      <img v-if="auth.photoURL" :src="auth.photoURL" class="avatar" />
      <v-icon v-else x-large class="default-avatar">account_circle</v-icon>
      <!-- <v-icon small>arrow_drop_down</v-icon> -->
      <!-- <v-icon small>keyboard_arrow_down</v-icon> -->
    </div>
    <v-list>
      <v-list-tile
        v-if="user"
        class="user-item"
      >
        <!-- <v-list-tile-action>
          <v-avatar :size="40">
            <img v-if="auth.photoURL" :src="auth.photoURL"/>
          </v-avatar>
        </v-list-tile-action> -->
        <v-list-tile-title>
          <div class="name">{{ user.name }}</div>
          <div class="email">{{ user.email }}</div>
        </v-list-tile-title>
      </v-list-tile>
      <!-- <v-list-tile @click="$router.push({ name: 'settings' })">
        <v-list-tile-action>
          <v-icon>settings</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>
          Налаштування
        </v-list-tile-title>
      </v-list-tile> -->
      <v-list-tile @click="$router.push({ name: 'logout' })">
        <v-list-tile-action>
          <v-icon>power_settings_new</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>
          Вихід
        </v-list-tile-title>
      </v-list-tile>


      <template v-if="isAdmin">
        <v-divider></v-divider>
        <v-subheader>Адміністрування</v-subheader>
        <v-list-tile :to="{ name: 'postAdd' }">
          <v-list-tile-action>
            <v-icon>add</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            Новий пост
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile :to="{ name: 'invites' }">
          <v-list-tile-action>
            <v-icon>person_add</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            Запрошення
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile :to="{ name: 'users' }">
          <v-list-tile-action>
            <v-icon>people</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            Користувачі
          </v-list-tile-title>
        </v-list-tile>
      </template>
    </v-list>
  </v-menu>
</template>

<script>

export default {
  name: 'MainMenu',
  computed: {
    auth() {
      return this.$store.state.auth;
    },
    user() {
      return this.$store.state.user;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
  methods: {
    track() {
      this.$ga.event('main-menu', 'opened', location.pathname);
    },
  },
};

</script>

<style scoped>

.list {
  padding-top: 0;
}

.user-item {
  background: #f5f5f5;
}

.user-item .list__tile__title {
  height: 36px;
}

.user-item .name {
  line-height: 20px;
}

.user-item .email {
  font-size: 12px;
  line-height: 14px;
  color: rgba(0,0,0, .7);
}

#app .default-avatar {
  color: rgba(0,0,0, .8);
}
</style>

<style>

.main-menu .user-item .list__tile {
  height: 60px;
}

</style>



// WEBPACK FOOTER //
// src/containers/MainMenu.vue